/* eslint-disable spaced-comment */
/*
* This file contains all the local stores the app uses to cache data for improved UX.
*/
import localforage from 'localforage';

export default function SetupStorage() {
  //#region Account specific stores
  const ac = localforage.createInstance({
    name: 'Accounts',
    storeName: 'accountdetails'
  })
  //#endregion

  //#region Remote specific stores
  const rd = localforage.createInstance({
    name: 'Remotes',
    storeName: 'remotedetails'
  });
  const rmu = localforage.createInstance({
    name: 'Remotes',
    storeName: 'monthlyusage'
  });
  const rdu = localforage.createInstance({
    name: 'Remotes',
    storeName: 'dailyusage'
  })
  const rcfg = localforage.createInstance({
    name: 'Remotes',
    storeName: 'remoteconfig'
  });
  //#endregion

  //#region Subscriptions
  const sub = localforage.createInstance({
    name: 'Subscriptions',
    storeName: 'subscriptiondetails'
  })
  const scfg = localforage.createInstance({
    name: 'Subscriptions',
    storeName: 'subscriptionconfig'
  })
  //#endregion

  //#region Device specific stores
  const dd = localforage.createInstance({
    name: 'Devices',
    storeName: 'devicedetails'
  })
  const dcfg = localforage.createInstance({
    name: 'Devices',
    storeName: 'deviceconfig'
  })
  //#endregion

  //#region Device specific stores
  const gd = localforage.createInstance({
    name: 'Groups',
    storeName: 'groupdetails'
  })
  const gcfg = localforage.createInstance({
    name: 'Groups',
    storeName: 'groupconfig'
  })
  //#endregion

  //#region User specific stores like app settings, dashboard and notifications
  const uas = localforage.createInstance({
    name: 'UserAppSettings',
    storeName: 'application'
  })
  const ds = localforage.createInstance({
    name: 'UserAppSettings',
    storeName: 'dashboard'
  })
  //#endregion
  Object.defineProperty(window, '$accountStore', { value: ac });
  Object.defineProperty(window, '$usageDailyStore', { value: rdu });
  Object.defineProperty(window, '$usageMonthlyStore', { value: rmu });

  Object.defineProperty(window, '$subscriptionStore', { value: sub });
  Object.defineProperty(window, '$subscriptionConfigStore', { value: scfg });

  Object.defineProperty(window, '$remoteStore', { value: rd });
  Object.defineProperty(window, '$remoteConfigStore', { value: rcfg });

  Object.defineProperty(window, '$deviceStore', { value: dd });
  Object.defineProperty(window, '$deviceConfigStore', { value: dcfg });

  Object.defineProperty(window, '$groupStore', { value: gd });
  Object.defineProperty(window, '$groupConfigStore', { value: gcfg });

  Object.defineProperty(window, '$userStore', { value: uas });
  Object.defineProperty(window, '$dashStore', { value: ds });
}
